var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 7C3.728 7 0 7.936 0 9.8V11.2H11.2V9.8C11.2 7.936 7.472 7 5.6 7ZM1.872 9.6C2.544 9.136 4.168 8.6 5.6 8.6C7.032 8.6 8.656 9.136 9.328 9.6H1.872ZM5.6 5.6C7.144 5.6 8.4 4.344 8.4 2.8C8.4 1.256 7.144 0 5.6 0C4.056 0 2.8 1.256 2.8 2.8C2.8 4.344 4.056 5.6 5.6 5.6ZM5.6 1.6C6.264 1.6 6.8 2.136 6.8 2.8C6.8 3.464 6.264 4 5.6 4C4.936 4 4.4 3.464 4.4 2.8C4.4 2.136 4.936 1.6 5.6 1.6ZM11.232 7.048C12.16 7.72 12.8 8.616 12.8 9.8V11.2H16V9.8C16 8.184 13.2 7.264 11.232 7.048ZM10.4 5.6C11.944 5.6 13.2 4.344 13.2 2.8C13.2 1.256 11.944 0 10.4 0C9.968 0 9.568 0.104 9.2 0.28C9.704 0.992 10 1.864 10 2.8C10 3.736 9.704 4.608 9.2 5.32C9.568 5.496 9.968 5.6 10.4 5.6Z",
    fill: "#2D3892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.92eca57f407a94ffc36d5f043e3c0ca6.svg";
export { ForwardRef as ReactComponent };